import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import { Alert, Box, Button, Chip, Container, Grid, IconButton, Typography } from '@mui/material';
import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import CountUp from 'react-countup';
import { useNavigate } from 'react-router-dom';
import TransparentModel from '../assets/images/StudentGirlModel.png';
import { configUrl } from '../config';
import getAllSubscriptionsService from '../services/OwnTestCreationServices/getAllSubscriptionsService';
import getMedineerPageCounts from '../services/getMedineerPageCounts';
import HeroTestDetailsPage from './HeroTestDetailsPage';
import HerosCollegePredictor from './HerosCollegePredictor';

export const HeroTS_Specific = ({ onHandleExplore, handleShowSubscription, onOpenPackagesModal, onPricingClick }) => {
    const hasFetchedSubscriptions = useRef(false);
    const hasFetchedLandingCounts = useRef(false);


    const navigate = useNavigate();
    axios.defaults.headers.common = {
        providerId: configUrl.MediNeerProviderId,
        contentProviderIds: configUrl.MediNeerContentProviderIds
    };
    // const fetch = async () => {
    //     try {
    //         let ids;
    //         // if (contentCuratorIds.length <= 0) {
    //         const data = await getProviderContentCuratorIds(configUrl.MediNeerProviderId);
    //         ids = data?.$values || [];
    //         // }
    //         axios.defaults.headers.common = {
    //             providerId: configUrl.MediNeerProviderId,
    //             contentProviderIds: ids // ?? contentCuratorIds
    //         };
    //         // console.log('gettinghere2', ids, 'xx', contentCuratorIds)
    //         // setContentCuratorIds(ids ?? contentCuratorIds);
    //     } catch (error) {
    //         console.log("error getting contentcuratorids");
    //     }
    // };


    const [formData, setFormData] = useState({
        name: '',
        mobile: '',
        email: '',
        course: '',
        examYear: '',
    });

    const [subscriptions, setSubscriptions] = useState(null);
    const [allCounts, setAllCounts] = useState(null);

    useEffect(() => {
        if (hasFetchedSubscriptions.current) return;
        hasFetchedSubscriptions.current = true;

        const fetchSubscriptions = async () => {
            try {
                const subscriptions = await getAllSubscriptionsService();
                if (subscriptions) {
                    setSubscriptions(subscriptions);
                }
            } catch (error) {
                console.error('Error fetching subscriptions:', error);
            }
        };

        fetchSubscriptions();
    }, []);


    useEffect(() => {
        if (hasFetchedLandingCounts.current) return;
        hasFetchedLandingCounts.current = true;

        const fetchCounts = async () => {
            try {
                const data = await getMedineerPageCounts();
                setAllCounts(data);
            } catch (error) {
                console.error('Landing counts error', error);
            }
        };

        fetchCounts();
    }, []);

    let freeResourceId = 4;
    return (
        <Box id="hero" sx={{ background: 'linear-gradient(135deg, hsl(210 100% 15%), hsl(210 80% 25%))', color: 'white', position: 'relative', overflow: 'hidden', pt: { xs: 8, md: 12 }, pb: 0 }}>
            <Box sx={{ position: 'absolute', inset: 0, backgroundImage: `url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNnoiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLW9wYWNpdHk9Ii4wNSIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9nPjwvc3ZnPg==')`, opacity: 0.1 }} />
            <Container maxWidth="100%" sx={{ position: 'relative', zIndex: 1 }}>
                {
                    handleShowSubscription === '#college-predictor' ?
                        <HerosCollegePredictor subscription={subscriptions?.length > 0 ? subscriptions[1] : null} /> :
                        handleShowSubscription === '#topic-pulse' ?
                            <HeroTestDetailsPage subscription={subscriptions?.length > 0 ? subscriptions[0] : null} />
                            :
                            <Grid container spacing={3} alignItems="start" justifyContent={'center'}>
                                <Grid item xs={11} md={9}>
                                    <Alert
                                        severity="info"
                                        icon={false}
                                        sx={{
                                            background: 'linear-gradient(to right, #3949ab, #5c6bc0)', // Inspired by header colors
                                            color: '#fff',
                                            fontWeight: 500,
                                            fontSize: '1.9rem',
                                            borderRadius: '10px',
                                            padding: '5px 20px',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            position: 'relative',
                                        }}
                                        action={
                                            <IconButton
                                                aria-label="close"
                                                color="inherit"
                                                size="medium"
                                                onClick={() => {
                                                    console.log('SP')
                                                }}
                                                sx={{ position: 'absolute', top: 6, right: 8 }}
                                            >
                                            </IconButton>
                                        }
                                    >
                                        <span>🔥 Limited-Time Offer — <b style={{ color: '#f8cb1e' }}>Unlock Engineering tests and boost your prep today! 🎉</b>&nbsp;</span>
                                        <Button
                                            variant="outlined"
                                            sx={{
                                                borderColor: '#fff',
                                                color: 'black',
                                                fontSize: "1.3rem",
                                                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color emoji"',
                                                fontWeight: 600,
                                                textTransform: 'none',
                                                ml: 1,
                                                backgroundColor: '#ec9706',    //'#f8cb1e',
                                                '&:hover': {
                                                    backgroundColor: '#c9bb88',
                                                    borderColor: '#fff',
                                                },
                                            }}
                                            // onClick={onOpenPackagesModal}  // or navigate("/college-predictor")
                                            onClick={() => navigate("/testseries-pcm")}
                                        >
                                            Know More
                                        </Button>
                                    </Alert>
                                </Grid>
                                <Grid item xs={12} md={6} sx={{ textAlign: 'left', paddingLeft: '21px' }}>
                                    <Chip icon={<SchoolOutlinedIcon sx={{ color: '#ffa200', fontSize: '2rem' }} />}
                                        label="India's Premier Test Platform"
                                        sx={{
                                            mb: 3,
                                            bgcolor: 'hsla(38, 100%, 50%, 0.2)',
                                            color: '#ffa200',
                                            backdropFilter: 'blur(10px)',
                                            border: '1px solid hsla(38, 100%, 50%, 0.3)',
                                            fontSize: '1.4rem',
                                            fontWeight: 600,
                                            height: 'auto',
                                            padding: '0.5rem 1rem 0.5rem 1rem',
                                            '& .MuiChip-icon': {
                                                color: '#ffa200',
                                                fontSize: '2rem',
                                            },
                                        }}
                                    />
                                    <Typography variant="h1" sx={{ fontSize: { xs: '2.5rem', md: '3.5rem', lg: '5rem' }, mb: 3, fontWeight: 700 }}>
                                        Prepare with India's Most Advanced <Box component="span" sx={{ color: 'secondary.main' }}>Test Series</Box>
                                    </Typography>
                                    <Typography variant="inherit" sx={{ mb: 4, opacity: 0.9, lineHeight: '2.75rem', fontSize: '2rem' }}>Master JEE, NEET & MHT-CET with AI-powered analytics, topic-wise tests, and comprehensive performance tracking.</Typography>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 6 }}>
                                        <Button size="large"
                                            variant="contained"
                                            color="secondary"
                                            endIcon={<span className="arrow">→</span>}
                                            sx={{
                                                px: 4,
                                                py: 1.5,
                                                borderRadius: '0.75rem',
                                                fontSize: '1.6rem',
                                                lineHeight: '2.4rem',
                                                textTransform: 'capitalize',
                                                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color emoji"',
                                                paddingLeft: '2.5rem',
                                                paddingRight: '2.5rem',
                                                height: '5.5rem',
                                                '& .arrow': {
                                                    display: 'inline-block',
                                                    transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                },
                                                '&:hover .arrow': {
                                                    transform: 'translateX(6px)',
                                                },
                                            }}
                                            // onClick={() => onHandleExplore()}
                                            onClick={() => onPricingClick()}
                                        >
                                            Explore Test Series
                                        </Button>
                                        {/* <Button size="large" variant="outlined"
                                            sx={{
                                                px: 4,
                                                py: 1.5,
                                                height: '5.5rem',
                                                border: 'solid 2px rgba(255, 255, 255, 0.3)',
                                                fontSize: '1.6rem',
                                                lineHeight: '2.4rem',
                                                textTransform: 'capitalize',
                                                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color emoji"',
                                                borderRadius: '0.75rem',
                                                color: 'white',
                                                '&:hover': {
                                                    borderColor: 'rgba(255, 255, 255, 0.5)',
                                                    bgcolor: 'rgba(255, 255, 255, 0.1)'
                                                },
                                            }}
                                             onClick={() => onHandleExplore()}
                                            
                                        >View Pricing Plans</Button> */}
                                    </Box>
                                    <Grid container spacing={1}>
                                        {
                                            [
                                                {
                                                    value: allCounts?.questionsCount || 0,
                                                    label: 'Questions',
                                                    suffix: '+'
                                                },
                                                {
                                                    value: allCounts?.studentsCount || 0,
                                                    label: 'Students'
                                                },
                                                {
                                                    value: allCounts?.testsCount || 0,
                                                    label: 'Tests',
                                                    suffix: '+'
                                                }
                                            ].map((stat) => (
                                                <Grid item xs={4} key={stat.label}>
                                                    <Typography variant="h3" sx={{ color: 'secondary.main', fontWeight: 700, mb: 0.5 }}>
                                                        {stat.value == 0 ?
                                                            <span>...</span> :
                                                            <CountUp
                                                                end={stat.value}
                                                                duration={2}
                                                                separator=","
                                                                suffix={stat.suffix || ''}
                                                            />
                                                        }
                                                        {/* {stat.value} */}
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ opacity: 0.8, fontSize: '1.4rem', lineHeight: '2rem' }}>{stat.label}</Typography>
                                                </Grid>
                                            ))}
                                    </Grid>
                                    {/* <Button
                                        variant="contained"
                                        size="large"
                                        color="secondary"
                                        
                                        sx={{
                                            mt: 5,
                                            fontSize: '1.4rem',
                                            lineHeight: '2.4rem',
                                            textTransform: 'capitalize',
                                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color emoji"',
                                            paddingLeft: '2rem',
                                            paddingRight: '2rem',
                                            height: '5rem',
                                        }}
                                        onClick={() => onPricingClick()}
                                    >
                                        View Pricing Plans
                                    </Button> */}
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Box
                                        sx={{
                                            position: 'relative',
                                            animation: 'fadeIn 0.7s ease-out 0.2s both',
                                            display: { xs: 'none', lg: 'block' },
                                            // boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
                                        }}
                                    >
                                        <Box
                                            component="img"
                                            src={TransparentModel}
                                            alt="EdTech platform preview"
                                            sx={{
                                                width: '100%',
                                                maxWidth: 485,
                                                height: 'auto',
                                                display: 'block',
                                                margin: '0 auto',
                                                borderRadius: 4,
                                            }}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                }
            </Container>
        </Box >
    );
};